import moment from "moment";
import momentTz from 'moment-timezone';
import {isNullOrUndefined} from './util';

const ajusteZeros = (n: number) => ('00' + n).slice(-2);

const tratarData = (date: Date | number) => {
    if (typeof date === 'number') {
        date = new Date(date);
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }

    return date;
};

export const calcularMinutosToHoras = (minutos : any) => {
	if (minutos < 0) {
		var minutosReverso = Math.abs(minutos);
		var h = Math.floor(minutosReverso / 60);
		var m = minutosReverso % 60;
		var hor = h < 10 ? "0" + h : h;
		var min = m < 10 ? "0" + m : m;
		return "-" + hor + ":" + min;
	}

	var h = Math.floor(minutos / 60);
	var m = minutos % 60;
	var hor = h < 10 ? "0" + h : h;
	var min = m < 10 ? "0" + m : m;
	return hor + ":" + min;
}

export const dateToString = (date: Date | number | number[], considerarHoras = false) => {
	if (!date) {
		return '';
	}

	if (Array.isArray(date)) {
		if (date.length === 5) {
			date.push(0);
		}
		if (date.length === 6) {
			date = new Date(date[0], date[1] - 1, date[2], date[3], date[4], date[5]);
		} else {
			throw new Error('Array de data inválido. Deve ter 5 ou 6 elementos.');
		}
	}
	date = tratarData(date as Date | number);

	const dataFinal = {
		dia: date.getDate(),
		mes: date.getMonth() + 1,
		ano: date.getFullYear(),
		hora: date.getHours(),
		minuto: date.getMinutes(),
		segundo: date.getSeconds()
	};

	const dataString = `${ajusteZeros(dataFinal.dia)}/${ajusteZeros(dataFinal.mes)}/${dataFinal.ano}`;
	const dataHorasString = `${ajusteZeros(dataFinal.dia)}/${ajusteZeros(dataFinal.mes)}/${dataFinal.ano} ` +
		`${ajusteZeros(dataFinal.hora)}:${ajusteZeros(dataFinal.minuto)}:${ajusteZeros(dataFinal.segundo)}`;

	return considerarHoras ? dataHorasString : dataString;
};

export const timeToString = (date: Date) => {
    if (!date) {
        return '';
    }
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return `${ajusteZeros(date.getHours())}:${ajusteZeros(date.getMinutes())}:${ajusteZeros(date.getSeconds())}`;
};

export const dateTimeToString = (date: Date) => {
    if (!date) {
        return '';
    }
    date = tratarData(date);
    const { dia, mes, ano } = { dia: date.getDate(), mes: date.getMonth() + 1, ano: date.getFullYear() };
    return `${ajusteZeros(dia)}/${ajusteZeros(mes)}/${ano} ${timeToString(date)}`;
};

export const timeToStringHHMM = (date: Date | number) => {
    if (!date) {
        return '';
    }

    const dataFinal: Date = tratarData(date);

    return `${ajusteZeros(dataFinal.getHours())}:${ajusteZeros(dataFinal.getMinutes())}`;
};

export const stringToTime = (hora: string) => {
    if (!hora) return null;
    try {
        const data = new Date();
        const [hour, minute] = hora.split(':');
        data.setHours(+hour, +minute, 0, 0);
        return data
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const stringToDate = (data: string): Date => {
    if (!data) {
        return null;
    }
    try {
        const [dia, mes, ano] = data.split('/');
        const [diaNumber, mesNumber, anoNumber] = [Number(dia), Number(mes) - 1, Number(ano)];

        const dataDate = new Date(anoNumber, mesNumber, diaNumber);

        if (dataDate.getDate() === diaNumber && dataDate.getMonth() === mesNumber && dataDate.getFullYear() === anoNumber) {
            return dataDate;
        }
    } catch {

        return null;
    }
    return null;
};

export const longToDate = (date: number): Date => {
    let data: Date;
    if (date) {
        data = new Date(date);
    }
    return data;
};


export const segundosToMilisegundos = (segundos: number): number => {
    return segundos * 1000;
};

export const minutosToMilisegundos = (minutos: number): number => {
	return minutos * 60 * 1000;
};

const numPad = function(val, size) {
	let s = String(val);
	while (s.length < (size || 2)) {s = '0' + s;}
	return s;
}

export const minutesToTime = (minutes: number): string => {
	if (minutes === 0) {
		return '00:00';
	}
	return `${minutes < 0 ? '-' : ''}${numPad (Number((Math.abs(340) - Number(Math.abs(340) % 60)) / 60) , 2)}:${numPad(Number(Math.abs(minutes)  % 60), 2)}`;
};


export const dateToStringYYYYMMDD = (date: Date | number) => {
	if (!date) {
		return '';
	}
	date = tratarData(date);
	const { dia, mes, ano } = { dia: date.getDate(), mes: date.getMonth() + 1, ano: date.getFullYear() };
	return `${ano}-${ajusteZeros(mes)}-${ajusteZeros(dia)}`;
}

export const dateToStringDDMMYYYYHHMM = (date: Date | number) => {
	if (!date) {
		return '';
	}
	date = tratarData(date);
	const { dia, mes, ano } = { dia: date.getDate(), mes: date.getMonth() + 1, ano: date.getFullYear() };
	return `${ajusteZeros(dia)}/${ajusteZeros(mes)}/${ano} ${timeToStringHHMM(date)}`;
}


export const validarHHMM = (hora: string) => {
	const regExp = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
	return regExp.test(hora);
}



export const compararSeHoraInicialMaiorOuIgualHoraFinal = (horaInicial: string, horaFinal: string) => {

	if (
		!horaInicial ||
		!horaFinal ||
		!horaInicial.trim() ||
		!horaFinal.trim()
	) {
		return true;
	}
	const [horaInicialHH, horaInicialMM] = horaInicial.split(":");
	const [horaFinalHH, horaFinalMM] = horaFinal.split(":");
	const horaInicialNumber = Number(horaInicialHH) * 60 + Number(horaInicialMM);
	const horaFinalNumber = Number(horaFinalHH) * 60 + Number(horaFinalMM);
	if (horaInicialNumber >= horaFinalNumber) {
		return true;
	}

	return false;
}

export const verificaDataHoraVazioOuNullo = (value: any) => {

	if(value == null)
		return true;

	if(value == '')
        return true;

	return  false;
}

export const obterSemanaAtual = (): {inicio: Date, fim: Date} =>{
	const inicio = moment().day(0).toDate();
	const fim = moment().day(6).toDate();
	inicio.setHours(0, 0, 0, 0)
	fim.setHours(23, 59, 59, 999)
	return {inicio, fim}
}

export const obterMesAtual = (): {inicio: Date, fim: Date} =>{

	const inicio = moment().startOf('month').toDate();
	const fim = moment().endOf('month').toDate();
	inicio.setHours(0, 0, 0, 0)
	fim.setHours(23, 59, 59, 999)
	return {inicio, fim}
}

export const obterTrimestreAtual = (): {inicio: Date, fim: Date} =>{
	const inicio = moment().subtract(3, 'months').toDate();
	const fim = moment().toDate();
	inicio.setHours(0, 0, 0, 0)
	fim.setHours(23, 59, 59, 999)
	return {inicio, fim}
}

export const checarPeriodoMaximoEntreDatas = (dataInicio, dataFim, periodoDias) => {
	const umDiaEmMilissegundos = 24 * 60 * 60 * 1000;
	const diffEmDias = Math.round((dataFim - dataInicio) / umDiaEmMilissegundos);
	return diffEmDias < periodoDias;

}

export const timeToDateLocalTimeConversao = (horario: string): string | null => {
	if (horario) {
		const dataAtual = new Date();
		const [horasSelecionadas, minutosSelecionados] = horario.split(':');
		dataAtual.setHours(parseInt(horasSelecionadas, 10), parseInt(minutosSelecionados, 10), 0, 0);
		const timezoneOffsetMinutes = dataAtual.getTimezoneOffset();
		dataAtual.setMinutes(dataAtual.getMinutes() - timezoneOffsetMinutes);

		return dataAtual.toISOString().replace('Z', '');
	} else {
		return null;
	}
};

export  const exibirDataIgnorarTimeZoneLocal = (dataMiliSegudnos, formato = 'DD/MM/YYYY HH:mm:ss' ) => {
	if (!isNullOrUndefined(dataMiliSegudnos)) {
		const serverTimezone = 'America/Sao_Paulo';
		return momentTz.tz(dataMiliSegudnos, serverTimezone).format(formato);
	}
	return '';
};


export const aplicarHoraStringEmDataEspecifica = (horario, data, isUltimoSegundo = false) => {
	const horarioSplit = horario.split(':');
	const dataFormat = new Date(data);
	dataFormat.setHours(Number(horarioSplit[0]));
	dataFormat.setMinutes(Number(horarioSplit[1]));
	dataFormat.setSeconds(isUltimoSegundo ? 59 : 0);
	return dataFormat;
};

export const calcularDiferencaEmHoras = (dataInicio, dataFim) => {
	const dataInicioMoment = moment(dataInicio);
	const dataFimMoment = moment(dataFim);
	const diferencaEmMilissegundos = dataFimMoment.diff(dataInicioMoment);
	const diferencaEmHoras = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60));
	return diferencaEmHoras;
};

export const ajustarFusoDinamico = (data): string => {
	const dataOriginal = new Date(data);
	const offsetEmMinutos = new Date().getTimezoneOffset();
	dataOriginal.setMinutes(dataOriginal.getMinutes() - offsetEmMinutos);

	const dia = String(dataOriginal.getDate()).padStart(2, '0');
	const mes = String(dataOriginal.getMonth() + 1).padStart(2, '0');
	const ano = dataOriginal.getFullYear();

	const horas = String(dataOriginal.getHours()).padStart(2, '0');
	const minutos = String(dataOriginal.getMinutes()).padStart(2, '0');
	const segundos = String(dataOriginal.getSeconds()).padStart(2, '0');

	return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
};
